import { render, staticRenderFns } from "./PreLicense.vue?vue&type=template&id=2f46d85c&scoped=true&"
import script from "./PreLicense.vue?vue&type=script&lang=js&"
export * from "./PreLicense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f46d85c",
  null
  
)

export default component.exports